module.exports = __webpack_public_path__ + "img/4.d21326e4.png";